export const EntityType = {
  USER_FILTERS: "user_filters",
};

export const QueryKeys = {
  userFilters: () => [EntityType.USER_FILTERS, "LIST"],
};
